// AgentDetailsModal.js
import React, { useState } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";

const contactMethod = [
  { name: "Email", val: 0 },
  { name: "Call", val: 1 },
  { name: "SMS", val: 2 },
];

const options = [
  { name: "Option 1", val: 0 },
  { name: "Option 2", val: 1 },
  { name: "Option 3", val: 2 },
];

const agentRole = [
  { name: "Buyer’s Agent", val: 0 },
  { name: "Seller’s Agent", val: 1 },
  { name: "Dual Agent", val: 2 },
];

const licenseType = [
  { name: "Sales person", val: 0 },
  { name: "Broker", val: 1 },
  { name: "Associate broker", val: 2 },
];

const specializations = [
  { name: "Residential", val: 0 },
  { name: "Commercial", val: 1 },
  { name: "Luxury", val: 2 },
  { name: "Rentals", val: 3 },
  { name: "Land", val: 4 },
];

const AgentDetailsModal = ({ item, getModalLayout, activityTab, setActivityTab }) => {
  const { name, phone, email } = item;
  const [date, setDate] = useState(null);
  const [showFullBio, setShowFullBio] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]); // must be array
  const [activeMenu, setActiveMenu] = useState("personal");

  const onToggleAgentMenu = () => {
    const agentMenu = document.getElementById("agentMenu");
    if (agentMenu) {
      agentMenu.classList.remove("show-agent-menu");
    }
  };

  // Accordion tabs wrapped for dynamic count
  const accordionTabs = (
    <Accordion multiple activeIndex={Array.from({ length: 10 }, (_, i) => i)}>
      <AccordionTab
        header={
          <label id="personal" className="form-label">
            <i className="ri-contacts-line"></i> &nbsp; Personal Information
          </label>
        }
      >
        <div className="form-group-grid">
          <div className="form-group">
            <label className="form-label">First Name </label>
            <input type="text" className="form-control" placeholder="Enter your name" />
          </div>
          <div className="form-group">
            <label className="form-label">Last Name </label>
            <input type="text" className="form-control" placeholder="Enter your name" />
          </div>
          {/* <div className="form-group">
            <label className="form-label">Display Name </label>
            <input type="text" className="form-control" placeholder="Enter your name" />
          </div> */}
          <div className="form-group">
            <label className="form-label">Date of birth </label>
            <Calendar value={date} onChange={(e) => setDate(e.value)} showIcon dateFormat="M dd, yy" appendTo="self" />
          </div>
          <div className="form-group">
            <label className="form-label">Profile photo </label>
            <input type="file" className="form-control form-control-upload" />
          </div>
          <div className="form-group form-group-full">
            <label className="form-label">Bio </label>
            <textarea type="text" className="form-control" rows={6} />
          </div>
        </div>
      </AccordionTab>
      <AccordionTab
        header={
          <label id="contact" className="form-label">
            <i className="ri-phone-line"></i> &nbsp; Contact Information
          </label>
        }
      >
        <div className="form-group-grid">
          <div className="form-group">
            <label className="form-label">Email Address </label>
            <input type="email" className="form-control" placeholder="Enter your email" />
          </div>
          <div className="form-group">
            <label className="form-label">Mobile Phone Number </label>
            <input type="text" className="form-control" placeholder="Enter your number" />
          </div>
          <div className="form-group">
            <label className="form-label">Alternate Phone Number </label>
            <input type="text" className="form-control" placeholder="Enter your number" />
          </div>
          <div className="form-group">
            <label className="form-label">Preferred Contact Method </label>
            <Dropdown
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.value)}
              options={contactMethod}
              optionLabel="name"
              optionValue="val"
              placeholder="Select contact method"
              appendTo="self"
              className="customised-dropdown"
            />
          </div>
          <div className="form-group">
            <label className="form-label">Time Zone </label>
            <input type="text" className="form-control" placeholder="Add your time zone" />
          </div>
        </div>
      </AccordionTab>
      <AccordionTab
        header={
          <label id="address" className="form-label">
            <i className="ri-map-pin-line"></i> &nbsp; Address Information
          </label>
        }
      >
        <div className="form-group-grid">
          <div className="form-group">
            <label className="form-label">Street Address </label>
            <input type="email" className="form-control" placeholder="Add street address" />
          </div>
          <div className="form-group">
            <label className="form-label">Country </label>
            <Dropdown
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.value)}
              options={options}
              optionLabel="name"
              optionValue="val"
              placeholder="Select Country"
              filter
              appendTo="self"
              className="customised-dropdown"
            />
          </div>
          <div className="form-group">
            <label className="form-label">State </label>
            <Dropdown
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.value)}
              options={options}
              optionLabel="name"
              optionValue="val"
              placeholder="Select State"
              filter
              appendTo="self"
              className="customised-dropdown"
            />
          </div>
          <div className="form-group">
            <label className="form-label">City </label>
            <Dropdown
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.value)}
              options={options}
              optionLabel="name"
              optionValue="val"
              placeholder="Select City"
              filter
              appendTo="self"
              className="customised-dropdown"
            />
          </div>
          <div className="form-group">
            <label className="form-label">Zipcode </label>
            <input type="text" className="form-control" placeholder="Enter your name" />
          </div>
        </div>
      </AccordionTab>
      <AccordionTab
        header={
          <label id="professional" className="form-label">
            <i className="ri-profile-line"></i> &nbsp; Professional Details
          </label>
        }
      >
        <div className="form-group-grid">
          <div className="form-group">
            <label className="form-label">Years of experience </label>
            <input type="email" className="form-control" />
          </div>
          <div className="form-group">
            <label className="form-label">Primary role </label>
            <Dropdown
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.value)}
              options={agentRole}
              optionLabel="name"
              optionValue="val"
              placeholder="Select contact method"
              appendTo="self"
              className="customised-dropdown"
            />
          </div>
          <div className="form-group">
            <label className="form-label">Specializations </label>
            <MultiSelect
              value={selectedOptions}
              onChange={(e) => setSelectedOptions(e.value)}
              options={specializations}
              optionLabel="name"
              placeholder="Specializations"
              maxSelectedLabels={3}
              appendTo="self"
              className="customised-dropdown w-full"
            />
          </div>
          <div className="form-group">
            <label className="form-label">Languages spoken </label>
            <input type="text" className="form-control" placeholder="Languages spoken" />
          </div>
          <div className="form-group">
            <label className="form-label">Service areas </label>
            <input type="text" className="form-control" placeholder="Add your area" />
          </div>
        </div>
      </AccordionTab>
      <AccordionTab
        header={
          <label id="licensing" className="form-label">
            <i className="ri-id-card-line"></i> &nbsp; Licensing & Compliance
          </label>
        }
      >
        <div className="form-group-grid">
          <div className="form-group">
            <label className="form-label">Real Estate License Number </label>
            <input type="text" className="form-control" />
          </div>
          <div className="form-group">
            <label className="form-label">License State </label>
            <Dropdown
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.value)}
              options={options}
              optionLabel="name"
              optionValue="val"
              placeholder="Select State"
              filter
              appendTo="self"
              className="customised-dropdown"
            />
          </div>
          <div className="form-group">
            <label className="form-label">License Type</label>
            <Dropdown
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.value)}
              options={licenseType}
              optionLabel="name"
              optionValue="val"
              placeholder="Select license type"
              appendTo="self"
              className="customised-dropdown"
            />
          </div>
          <div className="form-group">
            <label className="form-label">License Expiration Date </label>
            <Calendar value={date} onChange={(e) => setDate(e.value)} showIcon dateFormat="M dd, yy" appendTo="self" />
          </div>
          <div className="form-group">
            <label className="form-label">Upload License Document</label>
            <input type="file" className="form-control form-control-upload" />
          </div>
          <div className="form-group">
            <label className="form-label">MLS ID </label>
            <input type="text" className="form-control" />
          </div>

          <div className="form-group">
            <label className="form-label">NAR Membership ID (optional)</label>
            <input type="text" className="form-control" />
          </div>
          <div className="form-group form-option">
            <label className="form-label d-block">Realtor® Status</label>
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="tourStatus" id="inlineRadio1" value="Yes" />
              <label className="form-check-label" htmlFor="inlineRadio1">
                Yes
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="tourStatus" id="inlineRadio2" value="No" />
              <label className="form-check-label" htmlFor="inlineRadio2">
                No
              </label>
            </div>
          </div>
        </div>
      </AccordionTab>
      <AccordionTab
        header={
          <label id="brokerage" className="form-label">
            <i className="ri-id-card-line"></i> &nbsp; Brokerage Information
          </label>
        }
      >
        <div className="form-group-grid">
          <div className="form-group">
            <label className="form-label">Brokerage Name</label>
            <input type="text" className="form-control" />
          </div>
          <div className="form-group">
            <label className="form-label">Brokerage License Number</label>
            <input type="text" className="form-control" />
          </div>
          <div className="form-group">
            <label className="form-label">Brokerage Address</label>
            <input type="text" className="form-control" />
          </div>
          <div className="form-group">
            <label className="form-label">Brokerage Phone Number</label>
            <input type="text" className="form-control" />
          </div>
          <div className="form-group">
            <label className="form-label">Office MLS ID (optional)</label>
            <input type="text" className="form-control" />
          </div>
          <div className="form-group">
            <label className="form-label">Team Name (if part of a team)</label>
            <input type="text" className="form-control" />
          </div>
          <div className="form-group">
            <label className="form-label">Reporting Manager / Broker-in-Charge</label>
            <input type="text" className="form-control" />
          </div>
        </div>
      </AccordionTab>
      <AccordionTab
        header={
          <label id="commission" className="form-label">
            <i className="ri-exchange-dollar-line"></i> &nbsp; Commission & Business Settings
          </label>
        }
      >
        <div className="form-group-grid">
          <div className="form-group form-option">
            <label className="form-label d-block">Commission Type</label>
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="tourStatus" id="comType1" value="Percentage" />
              <label className="form-check-label" htmlFor="comType1">
                Percentage
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="tourStatus" id="comType2" value="Flat Fee" />
              <label className="form-check-label" htmlFor="comType2">
                Flat Fee
              </label>
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Default Commission Rate</label>
            <input type="text" className="form-control" />
          </div>
          <div className="form-group">
            <label className="form-label">Referral Fee (%)</label>
            <input type="text" className="form-control" />
          </div>
          <div className="form-group form-option">
            <label className="form-label d-block">W-9 Submitted</label>
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="tourStatus" id="SubmittedRadio1" value="Yes" />
              <label className="form-check-label" htmlFor="SubmittedRadio1">
                Yes
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="tourStatus" id="SubmittedRadio2" value="No" />
              <label className="form-check-label" htmlFor="SubmittedRadio2">
                No
              </label>
            </div>
          </div>
          <div className="form-group form-option">
            <label className="form-label d-block">Payment Method Preference</label>
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="tourStatus" id="PaymentRadio1" value="ACH" />
              <label className="form-check-label" htmlFor="PaymentRadio1">
                ACH
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="tourStatus" id="PaymentRadio2" value="Check" />
              <label className="form-check-label" htmlFor="PaymentRadio2">
                Check
              </label>
            </div>
          </div>
        </div>
      </AccordionTab>
      <AccordionTab
        header={
          <label id="online" className="form-label">
            <i className="ri-hashtag"></i> &nbsp; Online Presence
          </label>
        }
      >
        <div className="form-group-grid">
          <div className="form-group">
            <label className="form-label">Personal Website URL</label>
            <input type="text" className="form-control" />
          </div>
          <div className="form-group">
            <label className="form-label">Zillow Profile Link</label>
            <input type="text" className="form-control" />
          </div>
          <div className="form-group">
            <label className="form-label">Realtor.com Profile Link</label>
            <input type="text" className="form-control" />
          </div>
          <div className="form-group">
            <label className="form-label">LinkedIn Profile</label>
            <input type="text" className="form-control" />
          </div>
          <div className="form-group">
            <label className="form-label">Facebook Business Page</label>
            <input type="text" className="form-control" />
          </div>
          <div className="form-group">
            <label className="form-label">Instagram Handle</label>
            <input type="text" className="form-control" />
          </div>
        </div>
      </AccordionTab>
      <AccordionTab
        header={
          <label id="security" className="form-label">
            <i className="ri-shield-line"></i> &nbsp; Account & Security
          </label>
        }
      >
        <div className="form-group-grid">
          <div className="form-group">
            <label className="form-label">Username</label>
            <input type="text" className="form-control" />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input type="password" className="form-control" />
          </div>
          <div className="form-group">
            <label className="form-label">Confirm Password</label>
            <input type="password" className="form-control" />
          </div>
          <div className="form-group">
            <label className="form-label">Security Question (optional)</label>
            <input type="text" className="form-control" />
          </div>
          <div className="form-group form-option">
            <label className="form-label d-block">Two-Factor Authentication</label>
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="tourStatus" id="SubmittedRadio1" value="Enable" />
              <label className="form-check-label" htmlFor="SubmittedRadio1">
                Enable
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="tourStatus" id="SubmittedRadio2" value="Disable" />
              <label className="form-check-label" htmlFor="SubmittedRadio2">
                Disable
              </label>
            </div>
          </div>
        </div>
      </AccordionTab>
      <AccordionTab header={""}></AccordionTab>
    </Accordion>
  );

  const PropListings = (
    <div className="table-responsive">
      <table className="table align-middle text-nowrap table-hover table-centered property-table">
        <thead className="bg-light-subtle">
          <tr>
            <th>Properties Photo & Location</th>
            <th>Size</th>
            <th>Price</th>
            <th>Type</th>
            <th>Status</th>
            <th>Created Date</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div className="d-flex align-items-center gap-2">
                <div>
                  <img
                    alt=""
                    className="avatar-md rounded border border-light border-3"
                    src="https://barimedia.rapmls.com/norcalmls/listingpics/bigphoto/2024/10/09/a3ee84a7-632d-444a-9495-07aa47b3e871.jpg"
                    style={{ height: "46px", width: "46px" }}
                  />
                </div>
                <div className="prop-title">
                  <a className="text-dark fw-medium fs-14" href="/property-details/324080861" data-discover="true">
                    5700 Old River Road, Ukiah, California
                  </a>
                </div>
              </div>
            </td>
            <td>3,620 sqft</td>
            <td>$5,900,000</td>
            <td>Residential</td>
            <td>Active</td>
            <td>Aug 20, 2025</td>
          </tr>
          <tr>
            <td>
              <div className="d-flex align-items-center gap-2">
                <div>
                  <img
                    alt=""
                    className="avatar-md rounded border border-light border-3"
                    src="https://barimedia.rapmls.com/norcalmls/listingpics/bigphoto/2024/10/09/a3ee84a7-632d-444a-9495-07aa47b3e871.jpg"
                    style={{ height: "46px", width: "46px" }}
                  />
                </div>
                <div className="prop-title">
                  <a className="text-dark fw-medium fs-14" href="/property-details/324080861" data-discover="true">
                    5700 Old River Road, Ukiah, California
                  </a>
                </div>
              </div>
            </td>
            <td>3,620 sqft</td>
            <td>$5,900,000</td>
            <td>Residential</td>
            <td>Active</td>
            <td>Aug 20, 2025</td>
          </tr>
          <tr>
            <td>
              <div className="d-flex align-items-center gap-2">
                <div>
                  <img
                    alt=""
                    className="avatar-md rounded border border-light border-3"
                    src="https://barimedia.rapmls.com/norcalmls/listingpics/bigphoto/2024/10/09/a3ee84a7-632d-444a-9495-07aa47b3e871.jpg"
                    style={{ height: "46px", width: "46px" }}
                  />
                </div>
                <div className="prop-title">
                  <a className="text-dark fw-medium fs-14" href="/property-details/324080861" data-discover="true">
                    5700 Old River Road, Ukiah, California
                  </a>
                </div>
              </div>
            </td>
            <td>3,620 sqft</td>
            <td>$5,900,000</td>
            <td>Residential</td>
            <td>Active</td>
            <td>Aug 20, 2025</td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  const leadData = (
    <div className="table-responsive">
      <table className="table align-middle text-nowrap table-hover table-centered property-table">
        <thead className="bg-light-subtle">
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Property Name</th>
            <th>City</th>
            <th>Created Date</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div className="d-flex align-items-center gap-2 item-overflow-2">Jhon Wick</div>
            </td>
            <td>
              <a href="mailto:jhonwick@mail.com">jhonwick@mail.com</a>
            </td>
            <td>
              <a href="tel:+1(346) 346 3463">(346) 346 3463</a>
            </td>
            <td>
              <a className="" href="/property-details/324080861" data-discover="true">
                5700 Old River Road
              </a>
            </td>
            <td>Ukiah</td>
            <td>Sep 25, 2025</td>
          </tr>
          <tr>
            <td>
              <div className="d-flex align-items-center gap-2 item-overflow-2">Jhon Wick</div>
            </td>
            <td>
              <a href="mailto:jhonwick@mail.com">jhonwick@mail.com</a>
            </td>
            <td>
              <a href="tel:+1(346) 346 3463">(346) 346 3463</a>
            </td>
            <td>
              <a className="" href="/property-details/324080861" data-discover="true">
                5700 Old River Road
              </a>
            </td>
            <td>Ukiah</td>
            <td>Sep 25, 2025</td>
          </tr>
          <tr>
            <td>
              <div className="d-flex align-items-center gap-2 item-overflow-2">Jhon Wick</div>
            </td>
            <td>
              <a href="mailto:jhonwick@mail.com">jhonwick@mail.com</a>
            </td>
            <td>
              <a href="tel:+1(346) 346 3463">(346) 346 3463</a>
            </td>
            <td>
              <a className="" href="/property-details/324080861" data-discover="true">
                5700 Old River Road
              </a>
            </td>
            <td>Ukiah</td>
            <td>Sep 25, 2025</td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  return (
    <>
      {getModalLayout !== 2 && (
        <>
          <div id="popupSidebar" className="popup-sidebar">
            <div className="user-profile">
              <div className="user-picture">
                {/* <ProfileAvatar name={name} className="avatar-lg rounded-circle" /> */}
                <img className="rounded-circle" alt="avatar-3" src="/assets/images/agent-2.jpg"></img>
              </div>
              <h4 className="editable-title">{name}</h4>
              <ul className="custom-list">
                <li>DRE #: 01165140</li>
                <li>
                  <a href="">
                    <i className="text-primary ri-mail-line"></i> &nbsp;{email}
                  </a>
                </li>
                {phone && (
                  <li>
                    <a href="">
                      <i className="text-primary ri-phone-line"></i> &nbsp;{phone}
                    </a>
                  </li>
                )}
              </ul>
              <ul className="social-list mb-2">
                <li>
                  <a href="#">
                    <i className="ri-linkedin-fill"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="ri-facebook-fill"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="ri-instagram-line"></i>
                  </a>
                </li>

                <li>
                  <a href="#">
                    <i className="ri-twitter-x-line"></i>
                  </a>
                </li>
              </ul>
              <div className="agent-bio">
                <div className={showFullBio ? "bio-text expanded" : "bio-text"}>
                  <p>
                    I am a dedicated real estate professional with a strong focus on helping clients buy, sell, and invest with confidence. With in-depth market knowledge and a client-first approach,
                    I guide homeowners, investors, and first-time buyers through every stage of the real estate journey. I believe real estate is not just about properties, but about people, goals,
                    and long-term value. Known for integrity, transparency, and results, I work closely with clients to understand their needs and deliver the best possible outcomes. My commitment is
                    to make every real estate transaction smooth, informed, and successful.
                  </p>
                  <p>
                    I specialize in luxury real estate, representing discerning buyers and sellers of premium residences and exclusive properties. With a deep understanding of high-value markets and a
                    commitment to discretion, precision, and excellence, I deliver a personalized experience tailored to each client’s unique lifestyle and investment goals. Every transaction is
                    approached with strategic insight, market intelligence, and meticulous attention to detail. Renowned for professionalism, integrity, and results, I provide seamless guidance from
                    initial consultation to final closing. My focus is not just on exceptional properties, but on building lasting relationships grounded in trust and superior service.
                  </p>
                </div>

                <span className="read-toggle" onClick={() => setShowFullBio(!showFullBio)}>
                  {showFullBio ? "Read less" : "Read more"}
                </span>
              </div>
            </div>
          </div>
          <div id="agentMenu" className="agent-form-menu">
            <ul>
              <li>
                <a href="#personal" className={activeMenu === "personal" ? "active" : ""} onClick={() => setActiveMenu("personal")}>
                  <i className="ri-contacts-line"></i> Personal Information
                </a>
              </li>

              <li>
                <a href="#contact" className={activeMenu === "contact" ? "active" : ""} onClick={() => setActiveMenu("contact")}>
                  <i className="ri-phone-line"></i> Contact Information
                </a>
              </li>

              <li>
                <a href="#address" className={activeMenu === "address" ? "active" : ""} onClick={() => setActiveMenu("address")}>
                  <i className="ri-map-pin-line"></i> Address Information
                </a>
              </li>

              <li>
                <a href="#professional" className={activeMenu === "professional" ? "active" : ""} onClick={() => setActiveMenu("professional")}>
                  <i className="ri-profile-line"></i> Professional Details
                </a>
              </li>

              <li>
                <a href="#licensing" className={activeMenu === "licensing" ? "active" : ""} onClick={() => setActiveMenu("licensing")}>
                  <i className="ri-id-card-line"></i> Licensing & Compliance
                </a>
              </li>

              <li>
                <a href="#brokerage" className={activeMenu === "brokerage" ? "active" : ""} onClick={() => setActiveMenu("brokerage")}>
                  <i className="ri-id-card-line"></i> Brokerage Information
                </a>
              </li>

              <li>
                <a href="#commission" className={activeMenu === "commission" ? "active" : ""} onClick={() => setActiveMenu("commission")}>
                  <i className="ri-exchange-dollar-line"></i> Commission & Business Settings
                </a>
              </li>

              <li>
                <a href="#online" className={activeMenu === "online" ? "active" : ""} onClick={() => setActiveMenu("online")}>
                  <i className="ri-hashtag"></i> Online Presence
                </a>
              </li>

              <li>
                <a href="#security" className={activeMenu === "security" ? "active" : ""} onClick={() => setActiveMenu("security")}>
                  <i className="ri-shield-line"></i> Account & Security
                </a>
              </li>
            </ul>
          </div>
        </>
      )}

      <div id="popupContentGrid" className="popup-content-grid">
        <div id="activitySidebar" className="activity-bar user-activity">
          {activityTab === 1 && (
            <>
              <h4>{name} Profile</h4>
              <form className="custom-editable-form">{accordionTabs}</form>
            </>
          )}

          {activityTab === 2 && (
            <>
              <h4>Property listings</h4>
              {PropListings}
            </>
          )}
          {activityTab === 3 && (
            <>
              <h4>Leads</h4> {leadData}
            </>
          )}
          {activityTab === 4 && <h4>Tasks</h4>}
          {activityTab === 5 && <h4>Calendar</h4>}
          {activityTab === 6 && <h4>Email</h4>}
          {activityTab === 7 && <h4>Notes</h4>}
          {activityTab === 8 && <h4>Docs</h4>}
        </div>
      </div>

      <div className="activity-bar-ribbon">
        <div className="activity-list">
          <button
            onClick={() => {
              setActivityTab(1);
            }}
            className={activityTab === 1 ? "activityInfo-button active" : "activityInfo-button"}
          >
            <i className="ri-user-line"></i>
            <span>Profile</span>
          </button>
          <button
            onClick={() => {
              setActivityTab(2);
              onToggleAgentMenu();
            }}
            className={activityTab === 2 ? "activityInfo-button active" : "activityInfo-button"}
          >
            <i className="ri-list-indefinite"></i>
            <span>Listings</span>
          </button>
          <button
            onClick={() => {
              setActivityTab(3);
              onToggleAgentMenu();
            }}
            className={activityTab === 3 ? "activityInfo-button active" : "activityInfo-button"}
          >
            <i className="ri-list-check"></i>
            <span>Leads</span>
          </button>
          <button
            onClick={() => {
              setActivityTab(4);
              onToggleAgentMenu();
            }}
            className={activityTab === 4 ? "activityInfo-button active" : "activityInfo-button"}
          >
            <i className="ri-file-list-2-line"></i>
            <span>Tasks</span>
          </button>
          <button
            onClick={() => {
              setActivityTab(5);
              onToggleAgentMenu();
            }}
            className={activityTab === 5 ? "activityInfo-button active" : "activityInfo-button"}
          >
            <i className="ri-calendar-line"></i>
            <span>Calendar</span>
          </button>
          <button
            onClick={() => {
              setActivityTab(6);
              onToggleAgentMenu();
            }}
            className={activityTab === 6 ? "activityInfo-button active" : "activityInfo-button"}
          >
            <i className="ri-mail-line"></i>
            <span>Email</span>
          </button>
          <button
            onClick={() => {
              setActivityTab(7);
              onToggleAgentMenu();
            }}
            className={activityTab === 7 ? "activityInfo-button active" : "activityInfo-button"}
          >
            <i className="ri-add-line"></i>
            <span>Notes</span>
          </button>
          <button
            onClick={() => {
              setActivityTab(8);
              onToggleAgentMenu();
            }}
            className={activityTab === 8 ? "activityInfo-button active" : "activityInfo-button"}
          >
            <i className="ri-file-pdf-line"></i>
            <span>Docs</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default AgentDetailsModal;
